import Player from '@vimeo/player';
import $ from 'jquery';

const video = function video() {
  const videoSection = $('.video-section');
  let player;
  if (videoSection && videoSection.length) {
    const videSectionIframe = videoSection.find('iframe');
    player = new Player(videSectionIframe[0]);
    player.ready().then(() => {
      player.getPaused().then(paused => {
        if (paused) {
          player.setVolume(0);
          player.setLoop(true);
          player.play();
        }
      });
    });
  }

  const hasVideo = $('.has-video');
  if (hasVideo && hasVideo.length) {
    const hasVideoBtn = hasVideo.find('.large-play');
    hasVideoBtn.click(ev => {
      const btn = $(ev.target);
      const parent = btn.parent();
      const img = parent.find('img');
      btn.addClass('fade-out');
      img.addClass('fade-out');
      setTimeout(() => {
        btn.addClass('hide');
        img.addClass('hide');
      }, 350);
      const vid = new Player(parent.find('iframe')[0]);
      vid.play();

      vid.on('pause', () => {
        img.removeClass('hide');
        btn.removeClass('hide');
        setTimeout(() => {
          img.removeClass('fade-out');
          btn.removeClass('fade-out');
        }, 50);
      });
    });
  }
};
export default video;



// WEBPACK FOOTER //
// ./src/scripts/modules/video.js